<template>
  <el-dialog
    class="dialog"
    title="添加调出用户"
    width="1100px"
    :visible.sync="showPersonManage.flag"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    distroy-on-close
  >
    <div class="main-contant">
      <div class="left-tree">
        <LeftLazyTree @select="select" @clearCheckedNodes="clearCheckedNodes"/>
      </div>
      <div class="right-table">
        <search ref="search" @search="searchHandle" />
        <el-table
          ref="pageListTable"
          border
          :data="tableData"
          :row-key="getRowKeys"
          :row-style="{ color: '#51627D', fontWeight: 400 }"
          :header-cell-style="{
            background: '#DCE7FA',
            color: '#343C4A',
            fontWeight: 500,
          }"
          @selection-change="handleSelectionChanges"
        >
          <el-table-column
            type="selection"
            :selectable="selectInit"
            :reserve-selection="true"
            width="40"
          >
          </el-table-column>
          <el-table-column
            prop="userName"
            label="姓名"
            show-overflow-tooltip
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop="deptName"
            label="工作单位"
            show-overflow-tooltip
            width="200"
          >
          </el-table-column>
          <el-table-column
            prop="unitPosition"
            label="单位及职务"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="moveStatusName"
            label="调动状态"
            show-overflow-tooltip
          ></el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="sizeChange"
          @current-change="pageChange"
          :current-page="currentPage"
          :page-size="size"
          :page-sizes="[10, 50, 100, 500, 1000]"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          background
          hide-on-single-page
        />
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cancel" size="small">取消</el-button>
      <el-button type="primary" size="small" @click="confirm">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { pageByDepts } from "@/api/user";
import LeftLazyTree from "../components/leftLazyTree.vue";
import Search from "./search";

export default {
  components: {
    Search,
    LeftLazyTree
  },
  props: {
    defaultCheckedKeys: {
      type: Array,
      default: () => [],
    },
    showPersonManage: {
      type: Object,
      default: () => {
        return {
          flag: false,
        };
      },
    },
  },
  data() {
    return {
      props: {
        //树形
        label: "deptName",
        children: "zones",
        isLeaf: function(data, node) {
          return !data.hasChildren
        }
      },
      deptName: "",
      treeData: [],
      getRowKeys(row) {
        return row.uuid;
      },
      selectedMembers: [],
      tableData: [],
      total: 0,
      currentPage: 1,
      size: 10,
      userIdList: new Set(),
      nowPageIds: [],
      hasIds: [],
      originListSet: [],
      deptLevelCodes: []
    };
  },
  created() {
    if (this.defaultCheckedKeys) {
      this.selectedMembers = this.defaultCheckedKeys;
      this.originListSet = this.selectedMembers;
      this.hasIds = this.selectedMembers.map((x) => x.uuid);
      this.selectedMembers.map((x) => {
        this.userIdList.add(x.uuid);
      });
    }
  },
  methods: {
    cancel() {
      this.$emit("closeManage");
    },
    select(obj) {
      this.currentPage = 1;
      this.deptLevelCodes = obj.deptLevelCodes;
      this.getList(this.$refs.search.filters);
    },
    clearCheckedNodes() {
      this.deptLevelCodes = null;
    },
    handleSelectionChanges(rows) {
      // 并集
      let union = [...this.originListSet, ...rows];
      for (let i = 0, len = this.originListSet.length; i < len; i++) {
        for (let j = 0, length = rows.length; j < length; j++) {
          if (this.originListSet[i].uuid === rows[j].uuid) {
            union.splice(
              union.findIndex(
                (item) => item.uuid === this.originListSet[i].uuid
              ),
              1
            );
          }
        }
      }
      this.selectedMembers = union;
    },
    pageChange(page) {
      this.currentPage = page;
      this.getList(this.$refs.search.filters);
    },
    sizeChange(size) {
      this.size = size;
      this.getList(this.$refs.search.filters);
    },
    selectInit(row) {
      if (this.hasIds.length > 0) {
        const flag = !this.hasIds.includes(row.uuid);
        if (flag) {
          return !row.isCheck;
        } else {
          return false;
        }
      }
      return !row.isCheck;
    },
    // 历史选中回显置灰
    getList(param) {
      let params = {
        page: this.currentPage,
        limit: this.size,
        deptLevelCodes: this.deptLevelCodes
      };
      pageByDepts({
        ...params,
        ...param,
      }).then(({ code, data }) => {
        if (code !== 0) return;
        this.handleData(data);
      });
    },
    handleData(data) {
      let { records, total } = data;
      this.tableData = records;
      this.total = total;
      this.nowPageIds = this.tableData.map((x) => x.uuid);
      let rows = [];
      this.selectedMembers.map((x) => {
        this.userIdList.add(x.uuid);
      });
      this.nowPageIds.forEach((x, i) => {
        if (Array.from(this.userIdList).includes(x)) {
          rows.push(this.tableData[i]);
        }
      });
      setTimeout(() => {
        rows.forEach((row) => {
          this.$refs.pageListTable.toggleRowSelection(row, true);
        });
      }, 200);
    },
    // 条件筛选
    searchHandle(data) {
      this.currentPage = 1;
      this.getList(data);
    },
    confirm() {
      this.$emit("addSucceed", this.selectedMembers);
    },
  },
};
</script>

<style lang="scss" scoped>
.main-contant {
  display: flex;
  min-height: 500px;
}
.left-tree {
  width: 350px;
  margin-right: 10px;
  max-height: 450px;
}
.right-table {
  flex: 1;
}
.top-filter {
  margin-bottom: 10px;
}
.pagination {
  float: right;
}
.name-input {
  width: 250px;
  margin-right: 10px;
}
$text-color: #51627d;
$text-font: 14px;
@mixin text {
  color: $text-color;
  font-size: $text-font;
}
@mixin border {
  border: 1px solid #d7dbe0;
  border-radius: 2px;
}
@mixin panel {
  width: 48%;
  height: 300px;
  box-sizing: border-box;
  overflow: hidden;
}
.dialog {
  /deep/ .el-dialog__body {
    max-height: auto;
    .left-panel {
      float: left;
      @include border;
      padding: 10px;
      @include panel;
    }
    .right-panel {
      float: right;
      @include border;
      @include panel;
    }
    .member-tree {
      margin-top: 10px;
      height: calc(100% - 42px);
      overflow-y: auto;
      /deep/ .el-tree-node__label {
        @include text;
      }
    }
    .panel-header {
      background-color: #f2f3f4;
      height: 44px;
      display: flex;
      padding: 0 15px;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      & > span:first-child {
        @include text;
      }
    }
    .member-list {
      height: calc(100% - 64px);
      overflow-y: auto;
      margin: 10px 0;
      padding: 0 10px;
      li {
        list-style: none;
        padding: 8px 10px;
        @include text;
        &:hover {
          background-color: #3a85ff;
          color: #fff;
        }
      }
    }
  }
}
</style>
